<template>
  <div :class="{ desktop: isDesktop }" class="full-width">
    <el-switch
      v-if="withSpecific"
      v-model="anyVersion"
      active-text="Any version"
      inactive-text="Specific versions"
    />
    <div class="mt-1">
      <el-select
        v-if="anyVersion || !withSpecific"
        v-model="value.platforms"
        multiple
        placeholder="All"
        @update:modelValue="commonUpdated"
      >
        <el-option
          v-for="item in platformOptions"
          :key="item.key"
          :label="item.label"
          :value="item.key"
        />
      </el-select>
      <div v-else>
        <SpecificPlatformsSelector
          v-if="withSpecific"
          v-model="value.specific"
          @update:modelValue="specificUpdated"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import {
  Platform,
  PlatformLabel,
  PlatformLabels,
  SpecificVersion
} from '@/api/types'
import SpecificPlatformsSelector from './SpecificPlatformsSelector.vue'
import useResize from '@/hooks/useResize'

type PlatformEntry = {
  key: Platform
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'PlatformsSelector',
  components: {
    SpecificPlatformsSelector
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    withSpecific: {
      type: Boolean,
      default: true
    }
  },
  setup(props, context) {
    const initialAny = props.modelValue.specific
      ? props.modelValue.specific.length === 0
      : false
    const anyVersion = ref(initialAny)
    const value = ref(props.modelValue)
    const platformOptions = PlatformLabels.map<PlatformEntry>(
      (platformLabel: PlatformLabel) => {
        return {
          key: platformLabel.type_id,
          label: platformLabel.label,
          disabled: false
        }
      }
    )

    watch(anyVersion, (value, _oldValue) => {
      if (value === true) {
        context.emit('update:modelValue', {
          platforms: props.modelValue.platforms,
          specific: []
        })
      }
    })

    watch(
      (_: any) => props.modelValue,
      (val: any) => {
        value.value = val
      }
    )

    const commonUpdated = (newValue: Array<Platform>) => {
      context.emit('update:modelValue', {
        platforms: newValue,
        specific: props.modelValue.specific
      })
    }

    const specificUpdated = (newValue: Array<SpecificVersion<Platform>>) => {
      context.emit('update:modelValue', {
        platforms: props.modelValue.platforms,
        specific: newValue
      })
    }

    const { isDesktop } = useResize()

    return {
      anyVersion,
      value,
      commonUpdated,
      specificUpdated,
      platformOptions,
      isDesktop
    }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
